import SearchModalBestRankedPodcast from './SearchModalBestRankedPodcast';

export default SearchModalBestRankedPodcast;
